import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(front)/classes/ClassesClientView.tsx");
